import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import Icon from '@mercadoni/sinister/dist/cjs/Icon'

const IconOpenLogic = () => {
  const { colorSubheader: subheader } = useHeaderContext()

  const style = {
    color: subheader ? `var(${subheader})` : '#616161',
    marginLeft: 'var(--spacing-margin-xSmall)',
    marginRight: 'var(--spacing-margin-xSmall)',
    flexShrink: 0,
  }
  return <Icon className="ph-caret-down prev-arrow" size={16} style={style} />
}

const IconOpen = () => <IconOpenLogic />

export default IconOpen
